<div class="h-screen overflow-y-hidden">
  <app-header></app-header>
  <div class="container-fluid bg-enter-details h-full">
    <ng-template #qrModal xmlns="http://www.w3.org/1999/html">
      <mat-card-header class="m-b-20px subheading-2 bg-dark-grey p-2">
        <mat-card-title mat-dialog-title>
        <span class="subheading-2 text-xl">
          <mat-icon svgIcon="mat:book" class="text-indigo-700 primary-icon pt-2"></mat-icon>
          <span class="font-semibold">Scan Qr Code</span>
        </span>
          <i class="fa fa-window-close text-red-700 text-xl float-right text-bold cursor-pointer"
             (click)="closeModal()"></i>
        </mat-card-title>
      </mat-card-header>
      <div mat-dialog-content class="bg-enter-details">
        <div class="subheading-2">
          <div class="flex justify-center items-center mt-4">
            <img
              src="data:image/svg+xml;base64,{{qrCode}}"
              alt="QR Code">
          </div>
          <div class="text-white mb-4 mt-8 flex justify-center items-center">
            <div class="w-full md:w-[60%] p-4 md:p-0">
              <p>To keep your account safe, we use an extra layer of security called 2FA.</p>
              <ul>
                <li><span class="font-semibold">Step 1:</span> Download a TOTP-based Authenticator App:</li>
                <ul>
                  <li>– Authy</li>
                  <li>– Google Authenticator</li>
                  <li>– Microsoft Authenticator</li>
                </ul>
                <li><span class="font-semibold">Step 2:</span> Open the app and scan the QR code above.</li>
                <li><span class="font-semibold">Step 3:</span> After scanning, your app will start generating a 6-digit
                  code.
                  Enter your 6-digit code to complete login.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="p-4 shadow-light-up bg-dark-grey flex justify-end">
        <button mat-stroked-button color="primary" class="cursor-pointer float-left"
                [style.font-family]="'var(--vex-font)'" (click)="closeModal()">
          Close
        </button>
      </div>
    </ng-template>
    <div class="grid grid-cols-1 items-center md:grid-cols-2 h-full">
      <div class="p-6 mb-6 flex flex-col items-center">
        <div class="flex justify-center gap-4 mt-6 py-6">
          <input #inputField type="text" class="otp-input w-[40px] md:w-[50px] h-[40px] md:h-[50px]" numbersOnly
                 maxlength="1" (input)="verify()">
          <input #inputField type="text" class="otp-input w-[40px] md:w-[50px] h-[40px] md:h-[50px]" numbersOnly
                 maxlength="1" (input)="verify()">
          <input #inputField type="text" class="otp-input w-[40px] md:w-[50px] h-[40px] md:h-[50px]" numbersOnly
                 maxlength="1" (input)="verify()">
          <input #inputField type="text" class="otp-input w-[40px] md:w-[50px] h-[40px] md:h-[50px]" numbersOnly
                 maxlength="1" (input)="verify()">
          <input #inputField type="text" class="otp-input w-[40px] md:w-[50px] h-[40px] md:h-[50px]" numbersOnly
                 maxlength="1" (input)="verify()">
          <input #inputField type="text" class="otp-input w-[40px] md:w-[50px] h-[40px] md:h-[50px]" numbersOnly
                 maxlength="1" (input)="verify()">
        </div>
        <div class="mt-6 text-center">
          <p class="color-white text-center p-2"><span
            class="font-semibold text-lg">🔑 Enter the 6-Digit Code</span><br/>
            Open your authenticator app and enter the 6-digit verification code displayed there.<br>
            <span *ngIf="showQrImage">Don’t have an authenticator app yet?<span
              class="text-danger ml-1 underline cursor-pointer" (click)="openQrModal()">Click here</span></span>
            <span *ngIf="!showQrImage" class="text-danger">If you're unable to retrieve the code, kindly contact our administrator for assistance.</span>
          </p>
        </div>
      </div>
      <div class="p-6 mb-6">
        <img src="assets/images/OTP%201.png" alt="Image" class="w-[60%] m-auto h-auto"/>
      </div>
    </div>
  </div>
</div>
